import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Button } from 'antd';
import { logOut } from '../../store/routines';

function SessionExpiredNotification() {
  const dispatch = useDispatch();
  const history = useHistory();
  const isSessionError = useSelector((state) => state.auth.isSessionError);
  return (
    <Modal
      className="modal session-expired"
      title={
        <>
          <i className="fi-rr-lock icon" /> Session Expired
        </>
      }
      visible={isSessionError}
      closable={false}
      footer={[
        <Button
          key="submit"
          type="primary"
          className="btn red-action-btn no-flex"
          onClick={() => {
            history.replace({ pathname: '/app/login', state: undefined });
            dispatch(logOut());
          }}
        >
          Logout
        </Button>,
      ]}
    >
      <p>
        You have been signed out automatically due to inactivity and as a
        security precaution.
      </p>
    </Modal>
  );
}

export default SessionExpiredNotification;
